import * as React from "react";
import { UitkText } from "uitk-react-text";
import { decorateEditorialHtml } from "../../../ContentUtilities";
import { ViewExtraLarge, ViewLarge, ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
import { EditorialModel } from "src/typings/microserviceModels/content-flex-module";

const CONTENT_ID_COUNT = 3;
export const CardComparisonMobileApplyNowEditorial = (props: { items: EditorialModel[] }) => {
  const textClassNames = "m-t-padding-two uitk-type-center";
  const centerAlignClassNames = "uitk-type-center";
  const { items } = props;

  if (items.length !== CONTENT_ID_COUNT) {
    return null;
  }

  const [horizontalLine, applyNowTitle, applyNowText] = React.useMemo(
    () => items.map((item) => decorateEditorialHtml(item.text)),
    []
  );

  return (
    <Viewport>
      <ViewExtraLarge />
      <ViewLarge />
      <ViewMedium>
        <div>
          <div dangerouslySetInnerHTML={horizontalLine} />
          <div className={centerAlignClassNames}>
            <UitkText size={400} weight="medium">
              <div dangerouslySetInnerHTML={applyNowTitle} className={textClassNames} />
            </UitkText>

            <div className="uitk-type-400 m-t-padding-one">
              <div dangerouslySetInnerHTML={applyNowText} />
            </div>
          </div>
          <div dangerouslySetInnerHTML={horizontalLine} />
        </div>
      </ViewMedium>

      <ViewSmall>
        <div>
          <div dangerouslySetInnerHTML={horizontalLine} />
          <div className={centerAlignClassNames}>
            <UitkText size={400} weight="medium">
              <div dangerouslySetInnerHTML={applyNowTitle} className={textClassNames} />
            </UitkText>

            <div className="uitk-type-400 s-t-padding-one">
              <div dangerouslySetInnerHTML={applyNowText} />
            </div>
          </div>
          <div dangerouslySetInnerHTML={horizontalLine} />
        </div>
      </ViewSmall>
    </Viewport>
  );
};

export default CardComparisonMobileApplyNowEditorial;
